var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeightLift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M126,72v20.4h-2.4c-0.2-0.7-0.6-1.4-1.2-1.9L87.3,55.4c-0.9-0.9-2.2-1.5-3.6-1.5H60.5c-1.4,0-2.7,0.6-3.6,1.5L21.7,90.5 c-0.6,0.6-1,1.2-1.2,1.9H18V72H6.4v43.7H18V95.2h2.3c0.2,1,0.7,1.9,1.4,2.6c2,2,5.3,2,7.3,0l2.6-2.6h16v15.4c0,2.8,2.3,5.1,5.1,5.1 c2.8,0,5.1-2.3,5.1-5.1V95.2h28.3v15.4c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1V95.2h16l2.6,2.6c2,2,5.3,2,7.3,0 c0.7-0.7,1.2-1.7,1.4-2.6h2.2v20.5h11.6V72H126z M15.3,113H9.1V74.7h6.1V113z M52.8,79.7c-2.8,0-5.1,2.3-5.1,5.1v7.6H34.4 l26.1-26.1v26.1h-2.6v-7.6C57.9,82,55.6,79.7,52.8,79.7z M96.5,92.4v-7.6c0-2.8-2.3-5.1-5.1-5.1c-2.8,0-5.1,2.3-5.1,5.1v7.6h-2.6 V66.3l26.1,26.1H96.5z M134.9,113h-6.1V74.7h6.1V113z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72,
    cy: 41.1,
    rx: 9,
    ry: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightLift);
export default __webpack_public_path__ + "static/media/weightLift.70b7fa0d6986aed37139b4870bcb219f.svg";
export { ForwardRef as ReactComponent };